import React, {useState} from 'react'
import {AchTransferIcon, CardPaymentIcon, ArrowRightIcon} from '../assets'
import {ParagraphText, Icon} from '@thryvlabs/maverick'
import {AchPaymentForm} from './ach-payment-form'
import {BecsPaymentForm} from './becs-payment-form'
import {PaymentForm} from './recurly-payment-form'
import {useViewport} from '../utils/useViewport'
import {useDispatch, useSelector} from 'react-redux'
import {prevPaymentStep} from '../redux/paymentScreenViewSlice'
import {Toggle} from '../core/shared/Toggle'

import {getPaymentMethods} from './keap-partner/payment-information-components/constants/index'
// import {usePaymentOrder} from './keap-partner/payment-information-components/hooks/use-payment-order'

export const PaymentMethodComponent = ({
  paymentState,
  calculateTaxes,
  isTaxCalculated,
  setTaxCalculateStatus,
  paymentUUID,
  accountInformation,
  handleChangePaymentMethod,
  paymentMethod,
  setPaymentRequestState,
  country = 'US',
  keapPartnerLinkDetail,
  allowCountryChange = false,
  hideToggle = false,
  disclaimerText,
}) => {
  const [calculatingTaxes, setCalculatingTaxes] = useState({})
  const [isAddressUpdated, setIsAddressUpdated] = useState(false)
  const [isPaymentMethodLoading, setIsPaymentMethodLoading] = useState(false)
  const [checkBoxesValues, setCheckBoxesValues] = React.useState({
    agreedTerms: false,
    agreedPromotionalInfo: false,
    useBusinessAddressInfo: false,
    updateBillingAddress: false,
  })
  const [name, setName] = useState('')
  console.log(isAddressUpdated, name)
  console.log(paymentState)
  // const {is5Order} = usePaymentOrder()
  const is5Order = true
  const {isMobile} = useViewport()
  const dispatch = useDispatch()
  // const isDesktop = !isMobile
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  const {paymentCurrentStep} = useSelector(state => state.paymentScreenView)

  const paymentMethods = getPaymentMethods(keapPartnerLinkDetail?.country_code)
  // const calculatingTaxes= {}
  const paymentPreview = {}
  const handleCompleteOrder = () => {}

  const handleOnCheckBoxChange = ({target: {name}}) => {
    setCheckBoxesValues(prevState => ({
      ...prevState,
      [name]: !prevState[name],
    }))
  }
  console.log({isMobileViewEnable, paymentMethod})

  const renderMobilePaymentMethodView = () => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginBottom: '16px',
        }}
      >
        {paymentMethods.map((method, index) => {
          const isActive = paymentMethod?.value === method.value
          return (
            <button
              key={index}
              onClick={async () => {
                setIsPaymentMethodLoading(true)
                await handleChangePaymentMethod(method)
                setIsPaymentMethodLoading(false)
              }}
              disabled={isPaymentMethodLoading}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 16px',
                border: `2px solid ${isActive ? '#5378FC' : '#DDE1EA'}`,
                borderRadius: '10px',
                background: isActive ? '#F0F3FF' : '#ffffff',
                cursor: isPaymentMethodLoading ? 'not-allowed' : 'pointer',
                opacity: isPaymentMethodLoading && !isActive ? 0.5 : 1,
                width: '100%',
                textAlign: 'left',
              }}
            >
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: `2px solid ${isActive ? '#5378FC' : '#9CA3AF'}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {isActive && (
                  <div
                    style={{
                      width: '9px',
                      height: '9px',
                      borderRadius: '50%',
                      background: '#5378FC',
                    }}
                  />
                )}
              </div>
              {method.value === 'ach' ? (
                <AchTransferIcon color={isActive ? '#5378FC' : '#3D5199'} />
              ) : (
                <CardPaymentIcon color={isActive ? '#5378FC' : '#3D5199'} />
              )}
              <span
                style={{
                  fontFamily: 'Open Sans',
                  fontSize: '14px',
                  fontWeight: isActive ? 700 : 400,
                  color: isActive ? '#5378FC' : '#4D4D4D',
                }}
              >
                {method.name}
              </span>
            </button>
          )
        })}
        {isPaymentMethodLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '16px',
            }}
          >
            <div
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '3px solid #DDE1EA',
                borderTopColor: '#5378FC',
                animation: 'spin 0.7s linear infinite',
              }}
            />
          </div>
        )}
      </div>
    )
  }

  const renderPaymentMethodView = () => {
    const showDiscountNote = paymentMethod?.value === 'ach'
    const tabs = paymentMethods.map(method => {
      const isPlaid = method.name === 'Bank Transfer with ACH' && is5Order
      return {
        label: isPlaid
          ? 'Transfer with ACH'
          : method.value === 'card'
            ? 'Pay with Card'
            : method.value === 'becs'
              ? 'BECS'
              : method.name,
        value: method.value,
      }
    })
    const activeIndex = paymentMethods.findIndex(
      m => m.value === paymentMethod?.value,
    )
    return (
      <div className="mb-4">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <div
            style={{
              pointerEvents: isPaymentMethodLoading ? 'none' : 'auto',
              opacity: isPaymentMethodLoading ? 0.6 : 1,
            }}
          >
            <Toggle
              tabs={tabs}
              activeIndex={activeIndex}
              onChange={(tab, index) =>
                handleChangePaymentMethod(paymentMethods[index])
              }
              variant="pillFilled"
              renderTab={(tab, isActive) => (
                <>
                  {tab.value === 'ach' ? (
                    <AchTransferIcon color={isActive ? '#ffffff' : '#3D5199'} />
                  ) : (
                    <CardPaymentIcon color={isActive ? '#ffffff' : '#3D5199'} />
                  )}
                  {tab.label}
                  {isActive && <ArrowRightIcon />}
                </>
              )}
            />
          </div>
          {isPaymentMethodLoading && (
            <div
              style={{
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                border: '2px solid #DDE1EA',
                borderTopColor: '#5378FC',
                animation: 'spin 0.7s linear infinite',
                flexShrink: 0,
              }}
            />
          )}
        </div>
        {showDiscountNote && (
          <div className="achDiscountNote">
            Note: A monthly discount will be applied. Check your invoice for
            details.
          </div>
        )}
      </div>
    )
  }
  return (
    <>
      {isMobileViewEnable && !hideToggle ? (
        <>
          {paymentCurrentStep === 1 && renderMobilePaymentMethodView()}{' '}
          {paymentCurrentStep > 1 && paymentCurrentStep <= 3 && (
            <div className={`d-flex mb-4 pt-4`}>
              <Icon
                type="solid"
                variant="chevronLeft"
                className="mr-4"
                style={{
                  height: '20px',
                  width: '20px',
                }}
                onClick={() => {
                  dispatch(prevPaymentStep())
                }}
              />
              {paymentCurrentStep === 2 && (
                <ParagraphText variant="lg" className="font-weight-bold mb-0">
                  {paymentMethod?.value.includes('card')
                    ? 'Credit/Debit Card'
                    : paymentMethod?.value.includes('ach')
                      ? 'ACH'
                      : 'BECS'}
                </ParagraphText>
              )}
              {paymentCurrentStep === 3 && (
                <ParagraphText variant="lg" className="font-weight-bold mb-0">
                  Billing Address
                </ParagraphText>
              )}
            </div>
          )}
        </>
      ) : (
        <>{!hideToggle && renderPaymentMethodView()}</>
      )}

      {paymentMethod?.value.length > 0 ? (
        <>
          {paymentMethod?.value.includes('card') ? (
            <PaymentForm
              calculateTaxes={calculateTaxes}
              calculatingTaxes={calculatingTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              checkBoxesValues={checkBoxesValues}
              handleOnCheckBoxChange={handleOnCheckBoxChange}
              businessAddress={accountInformation}
              country={country || paymentState?.paymentInfo?.country}
              setName={setName}
              handleCompleteOrder={handleCompleteOrder}
              setIsAddressUpdated={setIsAddressUpdated}
              setTaxCalculateStatus={setTaxCalculateStatus}
              isTaxCalculated={isTaxCalculated}
              bizphone={accountInformation?.phone}
              is5Order={is5Order}
              isAddressUpdated={isAddressUpdated}
              paymentPreview={paymentPreview}
              accountInformation={accountInformation}
              setPaymentRequestState={setPaymentRequestState}
              keapPartnerLinkDetail={keapPartnerLinkDetail}
              allowCountryChange={allowCountryChange}
              showFirstSection={hideToggle || paymentCurrentStep === 2}
              showSecondSection={hideToggle || paymentCurrentStep === 3}
              disclaimerText={disclaimerText}
              skipOldMobile={hideToggle}
            />
          ) : paymentMethod?.value.includes('ach') ? (
            <AchPaymentForm
              uuid={paymentUUID}
              calculateTaxes={calculateTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              checkBoxesValues={checkBoxesValues}
              handleOnCheckBoxChange={handleOnCheckBoxChange}
              handleCompleteOrder={handleCompleteOrder}
              businessAddress={accountInformation}
              setName={setName}
              setIsAddressUpdated={setIsAddressUpdated}
              isMobile={isMobile}
              is5Order={false}
              accountInformation={accountInformation}
              showFirstSection={hideToggle || paymentCurrentStep === 2}
              showSecondSection={hideToggle || paymentCurrentStep === 3}
              country={country || paymentState?.paymentInfo?.country}
              disclaimerText={disclaimerText}
              allowCountryChange={allowCountryChange}
              skipOldMobile={hideToggle}
            />
          ) : (
            <BecsPaymentForm
              uuid={paymentUUID}
              calculateTaxes={calculateTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              checkBoxesValues={checkBoxesValues}
              handleOnCheckBoxChange={handleOnCheckBoxChange}
              handleCompleteOrder={handleCompleteOrder}
              businessAddress={accountInformation}
              setName={setName}
              setIsAddressUpdated={setIsAddressUpdated}
              isMobile={isMobile}
              is5Order={false}
              accountInformation={accountInformation}
              showFirstSection={hideToggle || paymentCurrentStep === 2}
              showSecondSection={hideToggle || paymentCurrentStep === 3}
              skipOldMobile={hideToggle}
              country={country || paymentState?.paymentInfo?.country}
              disclaimerText={disclaimerText}
              allowCountryChange={allowCountryChange}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
